import { IGlobalState } from '../index';
import { IState } from '../reducers/metadata';

export const getMetadata = (state: IGlobalState): IState['data'] => state.metadata.data;
